var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"light-box__container",attrs:{"name":"fade","mode":"in-out","tag":"div"}},[(_vm.getLightBoxImage)?_c('div',{key:"backdrop",staticClass:"background",on:{"click":_vm.closeLightBox}}):_vm._e(),(_vm.getLightBoxImage)?_c('img',{key:"image",staticClass:"light-box__image",attrs:{"src":_vm.getLightBoxImage}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }